import angular from "angular";
import { PeriodDateKind, PeriodType, Reports } from "@salaxy/core";
import { UiHelpers } from "../../services";

/**
 * Handles user interaction for displaying worker summary report
 */
export class WorkerSummaryReportDisplayController implements angular.IController {
  public static $inject = [
    "UiHelpers",
    "Reports"
  ];
  /**
   * Creates a new instance of WorkerSummaryReportDisplayController
   * @param uiHelpers - Salaxy ui helpers service.
   */
  constructor(
    private uiHelpers: UiHelpers,
    private reports: Reports

  ) { }

  /**
   * Parses workerId from report url
   * @param reportUrl url to be parsed
   * @returns workerId
   */
  public parseWorkerID(reportUrl: string) {
    const regex = new RegExp("[?&]" + "id" + "(=([^&#]*)|&|#|$)");
    const results = regex.exec(reportUrl);
    return results[2];
  }

  /**
   * Query WorkerSummaryReportData and display it in dialog
   * @param refDate date
   */
  public display(refDate: string, workerId: string, employerId: string): void {
    const data = {
      workerSummaryReportData: null,
      isLoading: true
    };
    // Parsing id from url because listing does not provide workerID yet
    this.reports.getWorkerSummaryReportData(refDate, workerId, employerId, PeriodType.Year, null, PeriodDateKind.SalaryDate ).then(workerSummaryReportData => {
      data.workerSummaryReportData = workerSummaryReportData;
      data.isLoading = false;
    });
    this.uiHelpers.showDialog(
      "salaxy-components/modals/report/WorkerSummaryReport.html",
      null,
      data,
      null,
      "landscape",
      true);
  }
}